import UserState from '../../../../models/store/modules/user-state.model';

import { mutations } from './mutations';

const state: UserState = {
  token: null,
  wkoUserData: null,
  b2xCoreProfile: null,
};

export default { state, mutations };
